import { Box, Tooltip } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { CHART_TYPOGRAPHY } from "./app/provider/patient/chart";

interface RenderWithTooltipProps {
  value: any;
}

const ELLIPSIS_SX = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  width: "100%",
  minWidth: 0,
  fontSize: CHART_TYPOGRAPHY.body5.fontSize,
};

const RenderWithTooltip = ({ value }: RenderWithTooltipProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    setIsTruncated(el.scrollWidth > el.clientWidth);
  }, [value]);

  return (
    <Tooltip title={isTruncated ? value : ""} placement="top" arrow>
      <Box ref={ref} sx={ELLIPSIS_SX}>
        {value ?? "-"}
      </Box>
    </Tooltip>
  );
};

export default RenderWithTooltip;

export const CustomTrimmedTooltip = ({ value }: RenderWithTooltipProps) => (
  <Tooltip title={value || ""} placement="top" arrow>
    <Box sx={ELLIPSIS_SX}>{value ?? ""}</Box>
  </Tooltip>
);
